import { Injectable } from "@angular/core";
import { Http, Response, URLSearchParams } from "@angular/http";
import {
    BASE_CONSTANTS,
    ITCIApplicationOwner,
    ITCIApplicationTenancyRequest,
    ITCIApplicationTenancyResponse,
    ITCIApplicationDeployResponse,
    SERVICE_URLS,
    IAOTSCUsers
} from "@tci/common";
import { Observable } from "rxjs";

@Injectable()
export class BaseAppHMChangeOwnerService {

    constructor(private http: Http) {

    }

    /**
     * Service function to get user list in current Org
     */
    getUsers(): Observable<IAOTSCUsers> {
        return this.http.get(`${SERVICE_URLS.TENANCY_USERS}`)
            .map((response: Response) =>  response.json());
    }

    /**
     * Service function to change app ownership
     * @param params
     */
    changeOwner(params: ITCIApplicationTenancyRequest): Observable<ITCIApplicationTenancyResponse> {
        return Observable.create( observer => {
            this.http.post(SERVICE_URLS.TENANCY, params).subscribe(
                succRsp => {
                    observer.next(succRsp.json());
                }, errRsp => {
                    observer.error(errRsp.json());
                }
            );
        });

        // return this.http.post(SERVICE_URLS.TENANCY, params)
        //     .map((response: Response) => response.json() );
    }

    getAppStatus(appId: string, desiredInstance: number): Observable<ITCIApplicationDeployResponse> {
        const queryParams = new URLSearchParams();
        queryParams.append("desiredInstanceCount", desiredInstance.toString());
        return this.http.get(`${SERVICE_URLS.TENANCY_STATUS}/${appId}`, {search: queryParams})
            .map((rsp: Response) =>  rsp.json());
    }

}
